import { useEffect } from 'react'
import useRebrandVersion from 'hooks/useRebrandVersion'
import { REBRAND_PALETTE_CLASS } from 'lib/theme/paletteVersion'

/** Keeps the document palette scope aligned with client-side experiment overrides. */
function usePaletteVersionBodyClass() {
  const rebrandVersion = useRebrandVersion()

  useEffect(() => {
    document.body.classList.toggle(REBRAND_PALETTE_CLASS, rebrandVersion === 'rebrand')
  }, [rebrandVersion])
}

export default usePaletteVersionBodyClass
